import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";

export function useAssignToEcgMutation() {
  const api = useAPIClient();
  return useMutation({
    mutationFn: async (payload: { patientId: string; visitId: string }) => {
      return api.ecg.assignDevice(payload, { force: true }).result;
    },
  });
}
